import AdministratorDriverInformation from "./DriverInformation/Driver.Administrator";
import SuperAgentDriverInformation from "./DriverInformation/Driver.SuperAgent";
import CompanyDriverInformation from "./DriverInformation/Driver.Company";
import CarInformation from "./CarInformation";

const Component = {
  AdministratorDriverInformation,
  SuperAgentDriverInformation,
  CompanyDriverInformation,
  CarInformation,
};

export default Component;
